<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col
        lg="12"
        style="display:block; text-align:center;padding-bottom:15px;font-size:1.2em;"
        v-if="total>0"
      >
        <span style="padding:5px;">Total Records:</span>
        <b>{{total}}</b>

      </b-col>
      <b-col lg="12">
        <b-table v-if="!message" style="background:#3a4149" :items="data" :fields="fields" title="Search Result">
          <template v-slot:cell(fnsid)="row">
            <a v-bind:href="customerReport + row.item.fnsId">{{ row.item.fnsId }}</a>
          </template>
        </b-table>
        <span v-else> {{ message }} </span>
        <div v-show="loading && !message" class="sk-double-bounce">
          <div class="sk-child sk-double-bounce1"></div>
          <div class="sk-child sk-double-bounce2"></div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>

import cTable from "./Table.vue";

export default {
  name: "tables",
  components: { cTable },
  data: () => {
    return {
      loading: false,
      total: null,
      message: null,
      data: [],
      fields: [
        { key: "fnsId", label: "FNSID", sortable: true },
        { key: "raNumber", label: "RANUM", sortable: true },
        { key: "serialNumber", label: "Serial#" },
        { key: "manufacturer", label: "Manufacturer" },
        { key: "model", label: "Model" },
        { key: "shippingDate", label: "Ship Date", formatter: (value, key, item) => {
            return item.shipDate ? item.shipDate.slice(5, 7) + '/' + item.shipDate.slice(8, 10) + '/' + item.shipDate.slice(0, 4) : null
          } },
        { key: "location", label: "Location" },
        { key: "price", label: "Price" },
      ],
      customerReport: process.env.VUE_APP_TRACKER_URL + 'tracker_private/includes/customerHarReportPublic.php?ftrack='
    }
  },
  watch: {
    $route (to, from) {
      this.fetchData()
    }
  },
  methods: {
    fetchData() {
      this.message = null;
      this.loading = true;
      let params = {};
      params = {
        type: this.$route.query.type,
        value: this.$route.query.value
      };
      this.$http
        .get("api/tec/tables/search.php", { params })
        .then(
          res => {
            if(res.data.message) {
              this.message = 'Nothing found.';
              this.total = 0;
            } else {
              this.data = res.data.records;
              this.total = res.data.records.length;
              this.loading = false;
            }
          },
          err => {
            console.log(err);
          }
        );
    }
  },
  mounted() {
    this.fetchData()
  }
}
</script>
